import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath?: string;
  ogImage?: string;
  ogType?: string;
  articleData?: {
    publishedTime?: string;
    modifiedTime?: string;
    author?: string;
  };
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogImage,
  ogType = 'website',
  articleData,
  jsonLd,
}: SEOHeadProps) {
  const location = useLocation();
  const canonicalUrl = `https://galgame-pc.com${canonicalPath || location.pathname}`;
  const defaultOgImage = 'https://readdy.ai/api/search-image?query=Galgame%20resource%20website%20PC%20platform%20with%20anime%20visual%20novel%20characters%2C%20clean%20modern%20design%2C%20warm%20color%20palette%2C%20Japanese%20game%20aesthetic%2C%20professional%20and%20inviting%20atmosphere&width=1200&height=630&seq=og-default&orientation=landscape';
  const siteName = 'Galgame资源网站PC';

  document.title = title;

  const updateMeta = () => {
    const setMeta = (name: string, content: string, propName?: string) => {
      let el: HTMLMetaElement | null;
      if (propName) {
        el = document.querySelector(`meta[property="${propName}"]`);
      } else {
        el = document.querySelector(`meta[name="${name}"]`);
      }
      if (!el) {
        el = document.createElement('meta');
        if (propName) {
          el.setAttribute('property', propName);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonicalEl) canonicalEl.setAttribute('href', canonicalUrl);

    setMeta('og:title', title, 'og:title');
    setMeta('og:description', description, 'og:description');
    setMeta('og:url', canonicalUrl, 'og:url');
    setMeta('og:type', ogType, 'og:type');
    setMeta('og:site_name', siteName, 'og:site_name');
    setMeta('og:image', ogImage || defaultOgImage, 'og:image');
    setMeta('og:locale', 'zh_CN', 'og:locale');

    setMeta('twitter:card', 'summary_large_image', 'twitter:card');
    setMeta('twitter:title', title, 'twitter:title');
    setMeta('twitter:description', description, 'twitter:description');
    setMeta('twitter:image', ogImage || defaultOgImage, 'twitter:image');

    if (articleData?.publishedTime) {
      setMeta('article:published_time', articleData.publishedTime, 'article:published_time');
    }
    if (articleData?.author) {
      setMeta('article:author', articleData.author, 'article:author');
    }
  };

  updateMeta();

  return (
    <>
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              Array.isArray(jsonLd) ? { '@graph': jsonLd } : jsonLd
            ),
          }}
        />
      )}
    </>
  );
}